import { Component, OnInit, Output, ViewChild , EventEmitter , ElementRef , ChangeDetectorRef,AfterViewInit, Inject } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { MatStepper } from '@angular/material/stepper';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import { GooglePlacesAPI , Maps} from '../services/googlePlaces.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-breed-selector-dialog',
  templateUrl: './breed-selector-dialog.component.html',
  styleUrls: ['./breed-selector-dialog.component.css']
}) 
export class BreedSelectorDialogComponent {  

  searchTerm: string = '';
  groupedBreeds: { letter: string, breeds: any[] }[] = [];

  constructor(
    public dialogRef: MatDialogRef<BreedSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.groupedBreeds = this.groupBreeds(data.breeds);
    console.log(this.groupedBreeds);
  }

  groupBreeds(breeds: any[]): { letter: string, breeds: any[] }[] {
    const grouped = breeds.reduce((acc, breed) => {
      const firstLetter = breed.name.charAt(0).toUpperCase();
      acc[firstLetter] = acc[firstLetter] || [];
      acc[firstLetter].push(breed);
      return acc;
    }, {});

    return Object.keys(grouped).sort().map(letter => ({
      letter,
      breeds: grouped[letter]
    }));
  }

  filterBreeds() {
    const filtered = this.data.breeds.filter(breed =>
      breed.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.groupedBreeds = this.groupBreeds(filtered);
  }

  selectBreed(breed: any) {
    this.dialogRef.close(breed);
  }


}
